import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "profile-dropdown",
  ref: "dropdown"
}
const _hoisted_2 = { class: "profile-avatar" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "avatar-placeholder"
}
const _hoisted_5 = {
  key: 0,
  class: "profile-name"
}
const _hoisted_6 = {
  key: 0,
  class: "dropdown-menu"
}
const _hoisted_7 = { class: "dropdown-header" }
const _hoisted_8 = { class: "header-avatar" }
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  class: "header-avatar-placeholder"
}
const _hoisted_11 = { class: "header-info" }
const _hoisted_12 = { class: "header-name" }
const _hoisted_13 = { class: "header-email" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["profile-button", { active: _ctx.isOpen, collapsed: _ctx.collapsed }]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleDropdown && _ctx.toggleDropdown(...args))),
      "aria-label": "User profile menu"
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.userProfileImage)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: _ctx.userProfileImage,
              alt: "Profile",
              class: "avatar-img"
            }, null, 8, _hoisted_3))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.userInitials), 1))
      ]),
      (!_ctx.collapsed)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.userFullName), 1))
        : _createCommentVNode("", true),
      (!_ctx.collapsed)
        ? (_openBlock(), _createElementBlock("svg", {
            key: 1,
            class: _normalizeClass(["dropdown-arrow", { rotated: _ctx.isOpen }]),
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            fill: "currentColor"
          }, [...(_cache[2] || (_cache[2] = [
            _createElementVNode("path", { d: "M7 10l5 5 5-5z" }, null, -1)
          ]))], 2))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_Transition, { name: "dropdown" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  (_ctx.userProfileImage)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        src: _ctx.userProfileImage,
                        alt: "Profile",
                        class: "header-avatar-img"
                      }, null, 8, _hoisted_9))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(_ctx.userInitials), 1))
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.userFullName), 1),
                  _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.userEmail), 1)
                ])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1)),
              _createVNode(_component_router_link, {
                to: "/settings",
                class: "dropdown-item",
                onClick: _ctx.closeDropdown
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createElementVNode("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    viewBox: "0 0 24 24",
                    fill: "currentColor"
                  }, [
                    _createElementVNode("path", { d: "M19.14 12.94c.04-.3.06-.61.06-.94 0-.32-.02-.64-.07-.94l2.03-1.58c.18-.14.23-.41.12-.61l-1.92-3.32c-.12-.22-.37-.29-.59-.22l-2.39.96c-.5-.38-1.03-.7-1.62-.94l-.36-2.54c-.04-.24-.24-.41-.48-.41h-3.84c-.24 0-.43.17-.47.41l-.36 2.54c-.59.24-1.13.57-1.62.94l-2.39-.96c-.22-.08-.47 0-.59.22L2.74 8.87c-.12.21-.08.47.12.61l2.03 1.58c-.05.3-.09.63-.09.94s.02.64.07.94l-2.03 1.58c-.18.14-.23.41-.12.61l1.92 3.32c.12.22.37.29.59.22l2.39-.96c.5.38 1.03.7 1.62.94l.36 2.54c.05.24.24.41.48.41h3.84c.24 0 .44-.17.47-.41l.36-2.54c.59-.24 1.13-.56 1.62-.94l2.39.96c.22.08.47 0 .59-.22l1.92-3.32c.12-.22.07-.47-.12-.61l-2.01-1.58zM12 15.6c-1.98 0-3.6-1.62-3.6-3.6s1.62-3.6 3.6-3.6 3.6 1.62 3.6 3.6-1.62 3.6-3.6 3.6z" })
                  ], -1),
                  _createElementVNode("span", null, "User Settings", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1)),
              _createElementVNode("button", {
                class: "dropdown-item logout-item",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args)))
              }, [...(_cache[4] || (_cache[4] = [
                _createElementVNode("svg", {
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 24 24",
                  fill: "currentColor"
                }, [
                  _createElementVNode("path", { d: "M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" })
                ], -1),
                _createElementVNode("span", null, "Logout", -1)
              ]))])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 512))
}